/**
 * Checked indexed read — the replacement for an `xs[i]!` non-null
 * assertion. Returns the element at `index`, or throws a `RangeError`
 * that names the collection (`what`), the index, and the length when the
 * slot is out of range.
 *
 * Unlike `nonnull` (`@tento-core/assert`), a present `null` or `NaN`
 * element is returned as-is — only an `undefined` slot (out of range, or
 * a hole) throws — so numeric series that legitimately carry `NaN` keep
 * their semantics.
 *
 * The message is only built on the throw path, so the call is cheap
 * enough for binary searches and per-point loops.
 */
export function elementAt<T>(
  xs: ArrayLike<T>,
  index: number,
  what: string,
): T {
  const value = xs[index];
  if (value === undefined) {
    throw new RangeError(
      `${what}: index ${index} out of range (length ${xs.length})`,
    );
  }
  return value;
}
